import React, { useContext, useEffect } from 'react';
import cl from './List.module.css';
import { AppContext } from "../../../../providers/appProvider";
import ErrorModal from '../../../UI/ErrorModal/ErrorModal';
import Pagination from '../../../UI/Pagination/Pagination';
import Add from '../Add/Add';
import Delete from '../Delete/Delete';
import Edit from '../Edit/Edit';
import tbl from '../../../../assets/Style/Table.module.css';
import { useAgentCRM } from '../../../../hooks/useAgentCRM';
import { useTranslation } from 'react-i18next';
import { baseFileURL } from '../../../../Api';

const AgentCRMList = () => {
  const { t } = useTranslation();
  const { agentCRMService } = useAgentCRM(50);
  const { appState, app } = useContext(AppContext);

  useEffect(() => {
    agentCRMService.fetchList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    agentCRMService.setFilter({
      ...agentCRMService.filter,
      [name]: value
    });
  };

  return (
    <div>
      <div className={cl.headMain}>
        <h1>{t('AgentCRM')}</h1>
        {app.hasPermission("AGENTCRM_ADD") && <Add agentCRMService={agentCRMService} />}
      </div>

      <div className={tbl.table + ' ' + cl.table}>
        <table>
          <thead>
            <tr>
              <th className={cl.id}>#</th>
              <th className={cl.pad0}>
                <input name="name" placeholder={t('Name')} value={agentCRMService.filter.name} onChange={handleInputChange} />
              </th>
              <th className={cl.pad0}>
                <input name="phone" placeholder={t('Phone')} value={agentCRMService.filter.phone} onChange={handleInputChange} />
              </th>
              <th className={cl.pad0}>
                <input name="email" placeholder={t('Email')} value={agentCRMService.filter.email} onChange={handleInputChange} />
              </th>
              <th>{t('File')}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {agentCRMService.items.map((item) => (
              <tr key={item.id}>
                <td className={cl.id}>{item.id}</td>
                <td>{item.name}</td>
                <td>{item.phone}</td>
                <td>{item.email}</td>
                <td>
                  {item.file &&
                    <a href={baseFileURL + item.file} target="_blank" rel="noreferrer">
                      {t('View')}
                    </a>
                  }
                </td>
                <td className={cl.btntbl}>
                  <div className={cl.btns}>
                    {app.hasPermission("AGENTCRM_EDIT") && <Edit agentCRMService={agentCRMService} defaultAgentCRM={item} />}
                    {app.hasPermission("AGENTCRM_DELETE") && <Delete agentCRMService={agentCRMService} defaultAgentCRM={item} />}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {appState.error && <ErrorModal message={appState.error} onClose={() => app.clearError(false)} />}

      <Pagination
        total={agentCRMService.total}
        perPage={agentCRMService.filter.limit}
        current={agentCRMService.filter.page}
        paginate={(page) => {
          agentCRMService.setFilter({
            ...agentCRMService.filter,
            page: page,
          });
        }}
        setLimit={(limit) => {
          agentCRMService.setFilter({
            ...agentCRMService.filter,
            limit: limit,
          });
        }}
      />
    </div>
  );
};

export default AgentCRMList;
